import dayjs from "dayjs";
import { MdClose } from "react-icons/md";
import { DATE_FORMAT } from "utils/constants";
import { FIELD_TYPES, getFieldConfig } from "./config";

const resolveValueLabel = (rawValue, fieldKey, selectionOptions) => {
  const options = selectionOptions?.[fieldKey];
  if (!options) return rawValue;
  const match = options.find((opt) => opt.value === rawValue);
  return match?.label || rawValue;
};

const formatChipLabel = (filter, translate, selectionOptions, fields) => {
  const fieldConfig = getFieldConfig(filter.fieldKey, fields);
  if (!fieldConfig) return "";

  const fieldLabel = translate.FIELDS[fieldConfig.labelKey];
  const operator = filter.operator;

  if (operator === "defined")
    return `${fieldLabel} : ${translate.OPERATORS.DEFINED}`;
  if (operator === "not_defined")
    return `${fieldLabel} : ${translate.OPERATORS.NOT_DEFINED}`;

  if (operator === "is" || operator === "is_not") {
    if (fieldConfig.type === FIELD_TYPES.DATE) {
      const formatted = filter.value
        ? dayjs(filter.value).format(DATE_FORMAT)
        : "";
      return `${fieldLabel} : ${formatted}`;
    }
    const valuesDisplay = (filter.values || [])
      .map((v) => resolveValueLabel(v, filter.fieldKey, selectionOptions))
      .join(", ");
    return `${fieldLabel} : ${valuesDisplay}`;
  }

  const operatorLabel =
    translate.OPERATORS[
      Object.keys(translate.OPERATORS).find(
        (k) => k === operator?.toUpperCase(),
      )
    ] || operator;

  const isDate = fieldConfig.type === FIELD_TYPES.DATE;
  const formatVal = (v) =>
    isDate && v ? dayjs(v).format(DATE_FORMAT) : v || "";

  if (operator === "between") {
    return `${fieldLabel} ${operatorLabel} ${formatVal(filter.value)} – ${formatVal(filter.value2)}`;
  }

  return `${fieldLabel} ${operatorLabel} ${formatVal(filter.value)}`;
};

const FilterChips = ({
  appliedFilters,
  onRemoveFilter,
  translate,
  selectionOptions,
  fields,
}) => {
  if (!appliedFilters || appliedFilters.length === 0) return null;

  return (
    <div className="advanced-filter__chips">
      <span className="advanced-filter__chips-label">
        {translate.ACTIVE_FILTERS}
      </span>
      {appliedFilters.map((filter, index) => (
        <span
          key={`chip-${filter.fieldKey}-${index}`}
          className="advanced-filter__chip"
        >
          {formatChipLabel(filter, translate, selectionOptions, fields)}
          <MdClose
            className="anticon-close"
            size={12}
            onClick={(e) => {
              e.stopPropagation();
              onRemoveFilter(index);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") onRemoveFilter(index);
            }}
          />
        </span>
      ))}
    </div>
  );
};

export default FilterChips;
